import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

export interface PageBackButtonProps {
  className?: string;
  label?: string;
  onClick?: () => void;
}

const PageBackButton = ({ className, label = 'Voltar', onClick }: PageBackButtonProps) => {
  return (
    <Button
      variant='link'
      color='default'
      size='sm'
      startIcon={<Icon name='arrow-left' />}
      className={cn('h-fit w-fit p-0', className)}
      onClick={onClick}
      data-testid='page-back-button'
    >
      {label}
    </Button>
  );
};

export default PageBackButton;
